import { RequestCard } from '@/globalComponents/requestCard';
import React, { useState } from 'react';
import Map from '../Map';
import Div from '@/shared/Div';
import { useContext } from 'react';
import { ServiceRequestContext } from '@/context/serviceRequestContext';

import { WebEngageContext } from '@/context/webengageContext';
import { useProductContext } from '@/context/productContext';
import useGTM from '@/hooks/useGTM';
import { GTMEventNames } from '@/types/gtm';

interface RequestTypeProps {
  clasNames?: string;
  data: {
    id: string;
    name: string;
    value: string;
  }[];
  setServiceType: Function;
  localServiceType: string;
  serviceTypeVisible: string;
}

export const RequestTypeCards = (props: RequestTypeProps) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const { data, setServiceType, localServiceType, serviceTypeVisible } = props;
  const { fireGTMEvent } = useGTM();
  const {
    state: { selectedProduct },
  } = useProductContext();
  const { dispatch: serviceAction } = useContext(ServiceRequestContext);

  const handleRequestItemClick = (
    index: number,
    { jobType, name, id: incidentId }: { jobType: string; name: string; id: string },
  ) => {
    fireGTMEvent(GTMEventNames.SERVICE_ISSUE_TYPE_SELECTED, {
      issue_type_selected: name,
      service_type_visible: serviceTypeVisible,
    });
    setActiveIndex(index);
    setServiceType(jobType);
    serviceAction.updateServiceType(jobType);
    serviceAction.updateIncidentId(incidentId);
    serviceAction.updateRepairType({
      defectType: name,
    });
  };

  if (!data.length) {
    return <></>;
  }
  return (
    <Div className="grid grid-cols-2 md:grid-cols-3 gap-s5 cursor-pointer w-full  md:mx-auto">
      <Map
        list={data}
        render={(item, index) => {
          if (selectedProduct.isRental && ['reinstall', '', 'uninstall'].includes(item.id))
            return null;
          return (
            <RequestCard
              onClickHandler={() => {
                handleRequestItemClick(index, item);
              }}
              key={item.id}
              data={item}
              activeIndex={activeIndex}
              index={index}
              localServiceType={localServiceType}
            />
          );
        }}
      />
    </Div>
  );
};
